import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AllAgents } from '../pages/agents';
import Dashboard from '../pages/dashboard';
import { Home } from '../pages/home';
import { AllHotels, ViewHotel } from '../pages/hotel';
import Login from '../pages/login';
import PasswordReset from '../pages/passwordReset';
import { AllProperties, ViewProperty } from '../pages/realEstate';
import { AllStores } from '../pages/shopping';
import { ViewStores } from '../pages/shopping/viewStores';
import { ScrollToTop } from '../component/scrollToTop';
import { AllCategories } from '../pages/categories/allCategories';
import { AllServices } from '../pages/categories/viewCategories';
import { Users, ViewUser } from '../pages/verification';
import { ViewFees } from '../pages/fees';
import CheckEmail from '../pages/passwordReset/checkEmail';
import InputNewPassword from '../pages/passwordReset/resetNewPassword';
import { Page404 } from '../pages/404';
import { AllPromotions, ViewPromotion } from '../pages/promotions';
import { AllAdmins } from '../pages/admins';
import { useAppSelector } from '../store/hooks';

export const AppRouter = () => {
  const auth = useAppSelector((state) => state.auth);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/password-reset" element={<PasswordReset />} />
        <Route path="/check-email" element={<CheckEmail />} />
        <Route path="/reset-password" element={<InputNewPassword />} />
        {!auth.user ? (
          <Route path="/" element={<Login />} />
        ) : (
          <Route path="/" element={<Dashboard />}>
            <Route path="" element={<Home />} />
            <Route path="categories" element={<AllCategories />} />
            <Route path="real-estate" element={<AllProperties />} />
            <Route path="hotel" element={<AllHotels />} />
            <Route path="hotel/view/:name/:id" element={<ViewHotel />} />
            <Route path="agents" element={<AllAgents />} />
            <Route
              path="real-estate/view/:name/:id"
              element={<ViewProperty />}
            />
            <Route path="shopping/view/:name/:id" element={<ViewStores />} />
            <Route path="shopping" element={<AllStores />} />
            <Route path="promotions" element={<AllPromotions />} />
            <Route path="promotions/view/:id" element={<ViewPromotion />} />
            <Route
              path="categories/all-services/:name/:id"
              element={<AllServices />}
            />
            <Route path="fees" element={<ViewFees />} />
            <Route path="verification" element={<Users />} />
            <Route path="verification/view/:id" element={<ViewUser />} />
            <Route path="promotions" element={<></>} />
            <Route path="admins" element={<AllAdmins />} />
          </Route>
        )}
        <Route path="*" element={<Page404 />} />
      </Routes>
    </BrowserRouter>
  );
};
